import {
    GET_PROJECT_ACTIVITY_BY_EMPLOYEE_ID_FAILURE,
    GET_PROJECT_ACTIVITY_BY_EMPLOYEE_ID_REQUEST,
    GET_PROJECT_ACTIVITY_BY_EMPLOYEE_ID_SUCCESS
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getProjectActivityByEmployeeIdReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PROJECT_ACTIVITY_BY_EMPLOYEE_ID_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case GET_PROJECT_ACTIVITY_BY_EMPLOYEE_ID_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_PROJECT_ACTIVITY_BY_EMPLOYEE_ID_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default getProjectActivityByEmployeeIdReducer;
